import { apiFetchV2 } from '@m/utils/http';

import type { GrpcCurrency } from '@m/types/grpc/GrpcTypes';

export const fetchStripeClientSecret = async (userId: number) => {
  const { stripeClientSecret } = await apiFetchV2<{ stripeClientSecret: string }>(
    `/user/${userId}/prepare-save-payment-method`,
    {
      method: 'POST',
    },
  );
  return stripeClientSecret;
};

export const fetchStripeClientSecretForExpressCheckout = async (
  userId: number,
  amount: GrpcCurrency,
) => {
  const response = await apiFetchV2<{ stripeClientSecret: string }>(
    `/user/${userId}/prepare-save-payment-method`,
    {
      method: 'POST',
      body: { amount },
    },
  );

  return response.stripeClientSecret;
};
